import * as React from "react";

import "./mask-mode.scss";

import {cs}       from "@Common/react/chain-services";
import {Invoke}   from "@Common/react/invoke";
import {scnv}     from "@Common/react/state-change-nested-value";
import {UseState} from "@Common/react/use-state";
import {chain}    from "@Common/utils/fs";
import {omit}     from "@Common/utils/objects";

import {isDevQuan}            from "../../../debug/is-dev-quan";
import {addVector}            from "../../common/add-vector";
import {centerOfSize}         from "../../common/center-of-size";
import {createRectFromCenter} from "../../common/create-rect-from-center";
import {floorSize}            from "../../common/floor-size";
import {getContainRatio}      from "../../common/get-contain-ratio";
import {multiplySize}         from "../../common/multiply-size";
import {multiplyVector}       from "../../common/multiply-vector";
import {subtractVector}       from "../../common/subtract-vector";
import {ImageObject}          from "../../image-object/image-object";

import {ControlPanel}  from "./control-panel/control-panel";
import {FileUpload}    from "./file-upload/file-upload";
import {MaskEditing}   from "./mask-editing/mask-editing";
import {ResizeOverlay} from "./resize-overlay/resize-overlay";

export const MaskMode = ({vpSize, onDone, next}) => cs(
    ["state", (_, next) => UseState({
        // getInitValue: () => isDevQuan() ? ({
        //     url: require("./Xpressdocs_Logo.jpg"),
        //     fileName: "Xpressdocs_Logo.jpg",
        //     initializing: true,
        // }) : null,
        next,
    })],
    ["obj", ({state}, next) => ImageObject({
        url: state.value?.url,
        adj: state.value,
        next,
    })],
    ["initialize", ({state, obj}, next) => next((cutout) => {

        if (cutout) {
            const scale = getContainRatio(vpSize, obj.rawSize);
            state.onChange({
                ...state.value,
                maskCutout: {
                    color: obj.getColorC({vpSize: obj.rawSize, opacity: 1, scale: 1, filter: {}, center: centerOfSize(obj.rawSize),})({x:0,y:0})(),
                    vpSize: chain(
                        multiplySize(obj.rawSize, scale),
                        floorSize,
                    ),
                },
                initializing: false,
                scale,
                center: null,
                opacity: state.value?.opacity ?? .5,
            });
        } else {
            const scale = 1 / getContainRatio(obj.rawSize, vpSize);
            state.onChange({
                ...state.value,
                initializing: false,
                scale,
                maskCutout: null,
                center: null,
                opacity: state.value?.opacity ?? .5,
            });
        }
    })],
    ({state, obj, initialize}) => next({
        modVpSize: (_) => state.value?.maskCutout?.vpSize ?? _,
        modObjects: (_) => ({
            imgObj: !state.value?.maskCutout?.imgCenter ? (
                _.imgObj
            ) : {
                ..._.imgObj,

                renderKey: {..._.imgObj.renderKey, center: state.value.maskCutout.imgCenter},
                getColorC: (params) => _.imgObj.getColorC({
                    ...params,
                    center: state.value.maskCutout.imgCenter,
                }),
            },
            maskObj: obj,
        }),
        modePanel: ({mobile, onCancel}) => (
            ControlPanel({
                mobile,
                onCancel,
                onDone: () => onDone(omit(state.value, ["initializing"])),
                hasFile: state.value?.url,
                fileUpload: ({mobile, onChanged}) => (
                    FileUpload({
                        mobile,
                        fileName: state.value?.fileName,
                        onRemove: () => state.change((s) => omit(s, ["url", "fileName", "maskCutout"])),
                        onChange: (file) => {
                            state.onChange({
                                initializing: true,
                                url: URL.createObjectURL(file),
                                fileName: file.name,
                            });
                            onChanged?.();
                        },
                    })
                ),
                editing: ({mobile}) => (
                    MaskEditing({
                        mobile,
                        state,
                        onCutout: initialize,
                    })
                ),
            })
        ),
        renderOverlay: ({frame, vpSize}) => cs(

            ({}) => (
                <div className="mask-mode-1s0 overlay">
                    {state.value?.initializing && obj && Invoke({
                        action: () => {
                            initialize(false);
                        },
                    })}

                    {isDevQuan() && obj && !state.value?.initializing && (
                        !state.value.maskCutout && MaskMover({frame, state, obj})
                    )}
                </div>
            ),
        ),
    }),
);


const MaskMover = ({frame, state, obj}) => ResizeOverlay({
    rect: createRectFromCenter(
        addVector(
            frame.center,
            !state.value.center ? (
                null
            ) : chain(
                subtractVector(
                    centerOfSize(obj.rawSize),
                    state.value.center,
                ),
                (_) => multiplyVector(_, frame.ratio * state.value.scale)
            ),
        ),
        multiplySize(obj.rawSize, frame.ratio * state.value.scale),
    ),
    onMove: () => {
        const center = state.value.center ?? centerOfSize(obj.rawSize);
        return (delta) => scnv(state, ["center"], () => addVector(
            center,
            multiplyVector(delta, -1 / (frame.ratio * state.value.scale)),
        ));
    },
});
